<template>
  <div class="column content-box">
    <woot-modal-header
      :header-title="$t('INTEGRATION_SETTINGS.SYONET.FORM.TITLE_EDIT')"
      :header-content="$t('INTEGRATION_SETTINGS.SYONET.FORM.DESC')"
    />
    <syonet-connection-form
      :value="value"
      :is-submitting="uiFlags.isUpdating"
      :is-testing-connection="uiFlags.isTestingConnection"
      @submit="onSubmit"
      @test-connection="onTestConnection"
      @cancel="onClose"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import SyonetConnectionForm from './SyonetConnectionForm';

export default {
  components: {
    SyonetConnectionForm,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      uiFlags: 'syonetConnections/getUIFlags',
    }),
  },
  methods: {
    async onTestConnection(syonetConnection) {
      try {
        const response = await this.$store.dispatch('syonetConnections/testConnection', {
          syonet_connection: syonetConnection,
        });

        const rowCount = response?.row_count;
        const suffix = Number.isFinite(rowCount)
          ? ` (${rowCount} records returned)`
          : '';

        this.showAlert(
          `${this.$t('INTEGRATION_SETTINGS.SYONET.TEST.API.SUCCESS_MESSAGE')}${suffix}`
        );
      } catch (error) {
        const message =
          error.response?.data?.message ||
          this.$t('INTEGRATION_SETTINGS.SYONET.TEST.API.ERROR_MESSAGE');
        this.showAlert(message);
      }
    },
    async onSubmit(syonetConnection) {
      try {
        await this.$store.dispatch('syonetConnections/update', {
          id: this.id,
          syonet_connection: syonetConnection,
        });
        this.showAlert(
          this.$t('INTEGRATION_SETTINGS.SYONET.EDIT.API.SUCCESS_MESSAGE')
        );
        this.onClose();
      } catch (error) {
        const message =
          error.response?.data?.message ||
          this.$t('INTEGRATION_SETTINGS.SYONET.EDIT.API.ERROR_MESSAGE');
        this.showAlert(message);
      }
    },
  },
};
</script>
